import { SET_BAR_STATE_FALSE, SET_BAR_MESSAGE, SET_BAR_STATE_TRUE } from "./SnackBarTypes";

const initailstate = {
  stage: false,
  message: "",
};

const snackBarReducer = (state = { initailstate }, action) => {
  switch (action.type) {
    case SET_BAR_STATE_TRUE:
      return {
        ...state,
        stage: true,
      };
    case SET_BAR_STATE_FALSE:
      return {
        ...state,
        stage: false,
      };
    case SET_BAR_MESSAGE:
      return {
        ...state,
        message: action.payload,
      };
    default:
      return state;
  }
};
export default snackBarReducer;
